// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"e3c6a490","326":"a45978a0","386":"5739dae4","402":"e2291ee5","583":"b2a579b4","874":"e1aae53d","903":"f4a2a01d","904":"90b9bf36","922":"de56ede7","923":"f7f9768a","980":"22fa2e2a"}[chunkId] + ".chunk.js";
};